import { Item } from '@react-stately/collections'
import { setAlignment } from 'common/Prose/Commands/table/mutation'
import { isTableCell } from 'common/Prose/utils/table'
import { Menu } from 'components/Menu/Menu'
import { type EditorView } from 'prosemirror-view'
import { useMemo } from 'react'
import { TableAlignmentBottom, TableAlignmentCenter, TableAlignmentTop } from 'almanac-ui/icons'

interface Props {
  closePicker?: () => void
  includeDropdownStyles?: boolean
  view: EditorView
}

const alignments = [
  {
    icon: TableAlignmentTop,
    title: 'Top aligned',
    verticalAlign: 'top',
  },
  {
    icon: TableAlignmentCenter,
    title: 'Centered',
    verticalAlign: 'middle',
  },
  {
    icon: TableAlignmentBottom,
    title: 'Bottom aligned',
    verticalAlign: 'bottom',
  },
] as const

type verticalAlignments = (typeof alignments)[number]['verticalAlign']

export const useVerticalAlignmentPicker2 = ({ closePicker, includeDropdownStyles = true, view }: Props) => {
  const activeAlignments = useMemo(() => {
    const foundAlignments = new Set<verticalAlignments>()
    const { selection } = view.state

    for (let {
      $from: { pos: from },
      $to,
    } of selection.ranges) {
      view.state.doc.nodesBetween(from, $to.pos, (node, pos) => {
        if (isTableCell(node)) foundAlignments.add(node.attrs.verticalAlign || 'top')
      })
    }
    return foundAlignments
  }, [view.state])

  return (
    <Menu
      showCheckmark={false}
      onAction={(alignment) => {
        if (typeof alignment !== 'string') return
        setAlignment(alignment)(view.state, view.dispatch)
        closePicker?.()
      }}
      selectedKeys={[...activeAlignments]}
      selectionMode="multiple"
    >
      {alignments.map((alignment) => {
        return (
          <Item key={alignment.verticalAlign} textValue={alignment.title}>
            <alignment.icon />
            {alignment.title}
          </Item>
        )
      })}
    </Menu>
  )
}
